<template>
  <div style="min-width: 100%">
    <h1 class="grey--text text--darken-2">Ваши уведомления</h1>

    <v-simple-table v-if="notifications.length">
      <template v-slot:default>
        <tbody>
          <tr v-for="notification in notifications" :key="notification.notificationID">
            <td>{{ notification.name }}</td>
            <td>{{ notification.calories }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <div class="mt-10 pa-5 elevation-1">
      <v-icon large class="mr-3">mdi-calendar-blank</v-icon>
      <span class="subtitle grey--text">Нет новых уведомлений</span>
    </div>

  </div>
</template>

<script>
export default {
  data: () => ({
    notifications: [
    ]
  }),
}
</script>
